import { render, staticRenderFns } from "./VotesRequiredInput.vue?vue&type=template&id=0d814ff4&"
import script from "./VotesRequiredInput.vue?vue&type=script&lang=js&"
export * from "./VotesRequiredInput.vue?vue&type=script&lang=js&"
import style0 from "./VotesRequiredInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VBtn,VIcon,VItem,VItemGroup})
